var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.5C0 11.246 10.746 0.5 24 0.5C37.248 0.516 47.984 11.252 48 24.5C48 37.754 37.254 48.5 24 48.5C10.746 48.5 0 37.754 0 24.5Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C10.746 0.5 0 11.246 0 24.5C0 37.754 10.746 48.5 24 48.5C37.254 48.5 48 37.754 48 24.5C47.984 11.252 37.248 0.516 24 0.5ZM37.854 16.9L24.164 35.478C23.492 36.37 22.224 36.548 21.332 35.876C21.322 35.868 21.314 35.862 21.304 35.854L11.528 28.038C10.666 27.348 10.526 26.088 11.216 25.226C11.906 24.364 13.166 24.224 14.028 24.914L22.18 31.436L34.634 14.534C35.246 13.614 36.488 13.366 37.408 13.978C38.328 14.59 38.576 15.832 37.964 16.752C37.928 16.804 37.892 16.852 37.854 16.9Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24 0.5C10.746 0.5 0 11.246 0 24.5C0 37.754 10.746 48.5 24 48.5C37.254 48.5 48 37.754 48 24.5C47.984 11.252 37.248 0.516 24 0.5ZM37.854 16.9L24.164 35.478C23.492 36.37 22.224 36.548 21.332 35.876C21.322 35.868 21.314 35.862 21.304 35.854L11.528 28.038C10.666 27.348 10.526 26.088 11.216 25.226C11.906 24.364 13.166 24.224 14.028 24.914L22.18 31.436L34.634 14.534C35.246 13.614 36.488 13.366 37.408 13.978C38.328 14.59 38.576 15.832 37.964 16.752C37.928 16.804 37.892 16.852 37.854 16.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0a5e69dd0aa9f53a1d6374d4d1cd9389.svg";
export { ForwardRef as ReactComponent };